<template>
  <div class="train-none-data">
    <div class="empty-block">
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">{{ emptyTxt }}</div>
      <!-- <div class="empty-txt" v-else>还没有报名训练营,快去报名吧~</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'trainNoneData',
  data() {
    return {
    }
  },
  computed: {
    emptyTxt() {
      let txt = '还没有报名训练营,快去报名吧~'
      if (this.$route.query.type === 'isDone') {
        txt = '当前训练营已结营,快去报名其它的训练营吧~'
      }
      return txt
    }
  },
  destroyed() {
    clearTimeout(this.settime)
  },
  mounted() {
    this.settime = setTimeout(() => {
      this.$router.push({ path: '/trainingList' })
    }, 2000)
  }
}
</script>
<style lang="less" scoped>
.empty-block {
  padding-top: 114px;
  box-sizing: border-box;
  .empty-img {
    width: 185px;
    display: block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  .empty-txt {
    text-align: center;
    font-size: 14px;
    color: rgba(0,0,0,0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/trainNoneData.vue